import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_CART_TEMPLATE } from './gql/getCartTemplate';

type QueryDataType = Pick<Query, 'getCartTemplate'>;
type OutgoingDataType = QueryDataType['getCartTemplate'];

const onError = getErrorLoggerFunction('getCartTemplate');

export const useGetCartTemplate = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_CART_TEMPLATE, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getCartTemplate);
        }
    }, [data]);

    return {
        cartTemplate: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
